import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  HStack,
  Select,
  Checkbox,
  Textarea,
  useToast,
  Tag,
  TagLabel,
  TagCloseButton,
  Wrap,
  WrapItem,
  Box,
  Progress,
  Text,
} from "@chakra-ui/react";
import { supabase } from "../../lib/supabaseClient";

const LANGUAGES = [
  { value: "한국어", label: "한국어" },
  { value: "영어", label: "영어" },
  { value: "기타", label: "기타" },
];

const GENRES = [
  { value: "트로트", label: "트로트" },
  { value: "Ballad (국내)", label: "발라드 (국내)" },
  { value: "Blues (국내)", label: "블루스 (국내)" },
  { value: "Dance (국내)", label: "댄스 (국내)" },
  { value: "Folk (국내)", label: "포크 (국내)" },
  { value: "R&B / Soul (국내)", label: "알앤비 / 소울 (국내)" },
  { value: "Rap / Hip-hop (국내)", label: "랩 / 힙합 (국내)" },
  { value: "Rock (국내)", label: "록 (국내)" },
  { value: "Electronica (국내)", label: "일렉트로니카 (국내)" },
  { value: "CCM (국내)", label: "CCM (국내)" },
  { value: "Jazz (국내)", label: "재즈 (국내)" },
  { value: "OST (국내)", label: "OST (국내)" },
  { value: "Blues (국외)", label: "블루스 (국외)" },
  { value: "Country (국외)", label: "컨트리 (국외)" },
  { value: "Electronica (국외)", label: "일렉트로니카 (국외)" },
  { value: "Folk (국외)", label: "포크 (국외)" },
  { value: "Pop (국외)", label: "팝 (국외)" },
  { value: "EDM (국외)", label: "EDM (국외)" },
  { value: "R&B / Soul (국외)", label: "알앤비 / 소울 (국외)" },
  { value: "Rap / Hip-hop (국외)", label: "랩 / 힙합 (국외)" },
  { value: "Rock (국외)", label: "록 (국외)" },
  { value: "CCM (국외)", label: "CCM (국외)" },
  { value: "Jazz (국외)", label: "재즈 (국외)" },
  { value: "OST (국외)", label: "OST (국외)" },
  { value: "한국전통음악", label: "한국전통음악" },
  { value: "어린이음악", label: "어린이음악" },
  { value: "종교음악", label: "종교음악" },
  { value: "Classic", label: "클래식" },
  { value: "New Age", label: "뉴에이지" },
  { value: "뮤직테라피", label: "뮤직테라피" },
  { value: "기타", label: "기타" },
  { value: "월드뮤직", label: "월드뮤직" },
  { value: "Electronica (J-Pop)", label: "일렉트로니카 (J-Pop)" },
  { value: "Pop (J-Pop)", label: "팝 (J-Pop)" },
  { value: "R&B / Soul (J-Pop)", label: "알앤비 / 소울 (J-Pop)" },
  { value: "Rap / Hip-hop (J-Pop)", label: "랩 / 힙합 (J-Pop)" },
  { value: "Rock (J-Pop)", label: "록 (J-Pop)" },
];
const MOODS = [
  { value: "Angry", label: "화난" },
  { value: "Busy & Frantic", label: "광란&들뜬" },
  { value: "Changing Tempo", label: "다이내믹 템포" },
  { value: "Chasing", label: "추적" },
  { value: "Dark", label: "어둠" },
  { value: "Dreamy", label: "몽환" },
  { value: "Eccentric", label: "괴짜" },
  { value: "Elegant", label: "우아함" },
  { value: "Epic", label: "웅장" },
  { value: "Euphoric", label: "유쾌" },
  { value: "Fear", label: "두려움" },
  { value: "Floating", label: "떠있는 느낌" },
  { value: "Funny", label: "코믹" },
  { value: "Glamorous", label: "화려함" },
  { value: "Happy", label: "행복" },
  { value: "Heavy & Ponderous", label: "무게감" },
  { value: "Hopeful", label: "희망" },
  { value: "Laid Back", label: "여유" },
  { value: "Marching", label: "행진" },
  { value: "Mysterious", label: "미스테리" },
  { value: "Peaceful", label: "평화로움" },
  { value: "Quirky", label: "별난" },
  { value: "Relaxing", label: "편안함" },
  { value: "Restless", label: "불안정함" },
  { value: "Romantic", label: "로맨틱" },
  { value: "Running", label: "운동" },
  { value: "Sad", label: "슬픔" },
  { value: "Scary", label: "무서움" },
  { value: "Sentimental", label: "감상적임" },
  { value: "Sexy", label: "섹시" },
  { value: "Smooth", label: "부드러움" },
  { value: "Sneaking", label: "은밀함" },
  { value: "Suspense", label: "긴장감" },
  { value: "Weird", label: "기묘함" },
  { value: "All moods", label: "전체 무드" },
];

const TrackModal = ({ isOpen, onClose, albumData, onSuccess }) => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [musicians, setMusicians] = useState([]);
  const [formData, setFormData] = useState({
    track_name_kr: "",
    track_name_en: "",
    track_number: "",
    track_main: false,
    musician: "",
    vocal_language: "",
    vocal: false,
    over_19: false,
    genre_depth4: "",
    lyricist_kr: "",
    lyricist_en: "",
    composer_kr: "",
    composer_en: "",
    arranger_kr: "",
    arranger_en: "",
    lyrics: "",
    description: "",
    mood: [],
    agree_copyrights: true,
    agree_distribution: true,
    agree_legal: true,
  });
  const [mp3File, setMp3File] = useState(null);
  const [wavFile, setWavFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState({ mp3: 0, wav: 0 });
  const [uploadStatus, setUploadStatus] = useState("");
  const [nextTrackNumber, setNextTrackNumber] = useState(1);

  // 뮤지션 목록 가져오기
  useEffect(() => {
    const fetchMusicians = async () => {
      try {
        const { data, error } = await supabase
          .from("musician")
          .select("*")
          .eq("user", albumData.user)
          .order("created_date", { ascending: false });

        if (error) throw error;
        setMusicians(data || []);
      } catch (error) {
        console.error("Error fetching musicians:", error);
        toast({
          title: "뮤지션 목록을 불러오는데 실패했습니다.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    if (isOpen) {
      fetchMusicians();
    }
  }, [isOpen, albumData.user]);

  useEffect(() => {
    const fetchNextTrackNumber = async () => {
      try {
        const { data: tracks, error } = await supabase
          .from("track")
          .select("track_number")
          .eq("album", albumData.id)
          .order("track_number", { ascending: true });

        if (error) throw error;

        const maxTrackNumber =
          tracks.length > 0
            ? Math.max(...tracks.map((t) => parseInt(t.track_number)))
            : 0;

        setNextTrackNumber(maxTrackNumber + 1);
        setFormData((prev) => ({
          ...prev,
          track_number: (maxTrackNumber + 1).toString(),
        }));
      } catch (error) {
        console.error("Error fetching track numbers:", error);
      }
    };

    if (isOpen) {
      fetchNextTrackNumber();
    }
  }, [isOpen, albumData.id]);

  const resetForm = () => {
    setFormData({
      track_name_kr: "",
      track_name_en: "",
      track_number: "",
      track_main: false,
      musician: "",
      vocal_language: "",
      vocal: false,
      over_19: false,
      genre_depth4: "",
      lyricist_kr: "",
      lyricist_en: "",
      composer_kr: "",
      composer_en: "",
      arranger_kr: "",
      arranger_en: "",
      lyrics: "",
      description: "",
      mood: [],
      agree_copyrights: true,
      agree_distribution: true,
      agree_legal: true,
    });
    setMp3File(null);
    setWavFile(null);
    setUploadProgress({ mp3: 0, wav: 0 });
    setUploadStatus("");

    // 파일 입력 필드 초기화
    const mp3Input = document.querySelector(
      'input[type="file"][accept=".mp3"]'
    );
    const wavInput = document.querySelector(
      'input[type="file"][accept=".wav"]'
    );
    if (mp3Input) mp3Input.value = "";
    if (wavInput) wavInput.value = "";
  };

  const uploadFile = async (file, path, file_track_code) => {
    try {
      const fileExt = file.name.split(".").pop()?.toLowerCase() || path;
      const timestamp = new Date().getTime();
      // 특수문자 제거 및 파일명 정리
      const cleanTrackCode = file_track_code.replace(/[^a-zA-Z0-9]/g, "_");
      const fileName = `${cleanTrackCode}_${timestamp}.${fileExt}`;
      const filePath = `${path}/${fileName}`;

      setUploadStatus(
        `"${file.name}" (${path.toUpperCase()}) 파일 업로드 중...`
      );

      const { data, error: urlError } = await supabase.storage
        .from("track")
        .createSignedUploadUrl(filePath);

      if (urlError || !data?.signedUrl) {
        console.error("URL 발급 오류:", urlError);
        throw new Error("Signed URL 발급 실패");
      }

      const signedUrl = data.signedUrl;

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", signedUrl, true);
        xhr.setRequestHeader(
          "Content-Type",
          file.type || (path === "mp3" ? "audio/mpeg" : "audio/wav")
        );

        xhr.upload.onprogress = (e) => {
          if (e.lengthComputable) {
            setUploadProgress((prev) => ({
              ...prev,
              [path]: Math.round((e.loaded / e.total) * 100),
            }));
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve();
          } else {
            console.error("업로드 실패 상세:", {
              status: xhr.status,
              statusText: xhr.statusText,
              response: xhr.response,
            });
            reject(new Error(`업로드 실패: ${xhr.status} ${xhr.statusText}`));
          }
        };
        xhr.onerror = () => {
          console.error("네트워크 오류 상세:", xhr);
          reject(new Error("네트워크 오류가 발생했습니다."));
        };
        xhr.send(file);
      });

      const { data: publicUrlData } = supabase.storage
        .from("track")
        .getPublicUrl(filePath);

      return publicUrlData?.publicUrl;
    } catch (error) {
      console.error("파일 업로드 중 오류 발생:", error);
      throw error;
    }
  };

  const uploadBothFiles = async ({ mp3File, wavFile, file_track_code }) => {
    const [mp3Url, wavUrl] = await Promise.all([
      uploadFile(mp3File, "mp3", file_track_code),
      uploadFile(wavFile, "wav", file_track_code),
    ]);
    return { mp3Url, wavUrl };
  };

  const getAudioDuration = (file) => {
    return new Promise((resolve) => {
      const audio = new Audio();
      audio.addEventListener("loadedmetadata", () => {
        resolve(Math.floor(audio.duration));
      });
      audio.src = URL.createObjectURL(file);
    });
  };

  const handleMoodToggle = (mood) => {
    setFormData((prev) => {
      const mood_list = prev.mood.includes(mood.value)
        ? prev.mood.filter((m) => m !== mood.value)
        : [...prev.mood, mood.value];
      return { ...prev, mood: mood_list };
    });
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      setUploadProgress({ mp3: 0, wav: 0 });
      setUploadStatus("음원 파일의 크기에 따라 시간이 다소 걸릴 수 있습니다.");

      // 필수값 검증
      const requiredFields = {
        track_number: "트랙 번호",
        track_name_kr: "트랙명",
        musician: "뮤지션",
        vocal_language: "언어",
        genre_depth4: "장르",
        composer_kr: "작곡가",
        composer_en: "작곡가(영문)",
      };

      const missingFields = Object.entries(requiredFields)
        .filter(([key]) => !formData[key])
        .map(([_, label]) => label);

      if (missingFields.length > 0 || !mp3File || !wavFile) {
        const missingFiles = [];
        if (!mp3File) missingFiles.push("MP3 파일");
        if (!wavFile) missingFiles.push("WAV 파일");

        const errorMessage = [...missingFields, ...missingFiles].join(", ");

        toast({
          title: "필수 정보 누락",
          description: `${errorMessage}`,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // commission_rate 결정 로직 추가
      let commissionRate = 10;
      if (albumData.user) {
        const { data: contractData } = await supabase
          .from("shorts_contract")
          .select("commission")
          .eq("contractor", albumData.user)
          .single();
        if (contractData && contractData.commission) {
          commissionRate = contractData.commission;
        }
      }

      const { data: existingTracks, error: checkError } = await supabase
        .from("track")
        .select("track_number")
        .eq("album", albumData.id)
        .eq("track_number", parseInt(formData.track_number));

      if (checkError) {
        console.error("트랙 번호 확인 중 오류:", checkError);
        throw checkError;
      }

      if (existingTracks && existingTracks.length > 0) {
        toast({
          title: "트랙 번호 중복",
          description: "이미 존재하는 트랙 번호입니다.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const runningTimeSec = await getAudioDuration(mp3File);
      const track_number = formData.track_number.toString().padStart(2, "0");
      const track_code = `S${albumData.code_album}${track_number}`;
      const file_track_code = `${track_code}_${track_number}`;

      setUploadStatus("MP3 및 WAV 파일 업로드 중...");

      const { mp3Url, wavUrl } = await uploadBothFiles({
        mp3File,
        wavFile,
        file_track_code,
      });

      setUploadProgress({ mp3: 100, wav: 100 });
      setUploadStatus("트랙 정보 저장 중...");

      const trackData = {
        track_number: parseInt(formData.track_number),
        track_name_kr: formData.track_name_kr,
        track_name_en: formData.track_name_en,
        track_main: Boolean(formData.track_main),
        musician: formData.musician,
        vocal_language: formData.vocal_language,
        vocal: formData.vocal,
        over_19: formData.over_19,
        genre_depth4: formData.genre_depth4,
        lyricist_kr: formData.lyricist_kr,
        lyricist_en: formData.lyricist_en,
        composer_kr: formData.composer_kr,
        composer_en: formData.composer_en,
        arranger_kr: formData.arranger_kr,
        arranger_en: formData.arranger_en,
        lyrics: formData.lyrics,
        description: formData.description,
        mp3_ar: mp3Url,
        wav_ar: wavUrl,
        mood: formData.mood,
        album: albumData.id,
        track_code: track_code,
        sale_type: "발매 음반",
        running_time_sec: runningTimeSec,
        agree_copyrights: true,
        agree_distribution: true,
        agree_legal: true,
        agree_playlisting: true,
        agree_terms: true,
        commission_rate: commissionRate,
      };

      const { error: insertError } = await supabase
        .from("track")
        .insert(trackData);

      if (insertError) throw insertError;

      setUploadStatus("트랙 추가 완료!");

      toast({
        title: "트랙 추가 성공",
        description: "새로운 트랙이 성공적으로 추가되었습니다.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      resetForm();
      onClose();
      onSuccess();
    } catch (error) {
      console.error("Error adding track:", error);
      toast({
        title: "트랙 추가 실패",
        description: error.message || "트랙 추가 중 오류가 발생했습니다.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
      setUploadProgress({ mp3: 0, wav: 0 });
      setUploadStatus("");
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent maxW="800px" borderRadius="xl" boxShadow="xl">
        <ModalHeader
          bg="blue.50"
          borderTopRadius="xl"
          py={4}
          fontSize="xl"
          fontWeight="bold"
          color="blue.700"
        >
          트랙 추가
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={6}>
          <VStack spacing={4}>
            <HStack width="100%" spacing={4}>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  트랙 번호
                </FormLabel>
                <Input
                  name="track_number"
                  value={formData.track_number}
                  onChange={(e) =>
                    setFormData({ ...formData, track_number: e.target.value })
                  }
                  type="number"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                  isReadOnly
                  bg="gray.50"
                />
              </FormControl>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  타이틀 곡
                </FormLabel>
                <Checkbox
                  name="track_main"
                  isChecked={formData.track_main}
                  onChange={(e) =>
                    setFormData({ ...formData, track_main: e.target.checked })
                  }
                  colorScheme="blue"
                >
                  타이틀 곡으로 지정
                </Checkbox>
              </FormControl>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  가창/연주
                </FormLabel>
                <Checkbox
                  name="vocal"
                  isChecked={formData.vocal}
                  onChange={(e) =>
                    setFormData({ ...formData, vocal: e.target.checked })
                  }
                  colorScheme="blue"
                >
                  가창곡
                </Checkbox>
              </FormControl>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  19금 여부
                </FormLabel>
                <Checkbox
                  name="over_19"
                  isChecked={formData.over_19}
                  onChange={(e) =>
                    setFormData({ ...formData, over_19: e.target.checked })
                  }
                  colorScheme="blue"
                >
                  19금 (성인)
                </Checkbox>
              </FormControl>
            </HStack>

            <Box width="100%">
              <FormControl isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  트랙명
                </FormLabel>
              </FormControl>
              <Text fontSize="sm" color="gray.500" mb={2}>
                국문에도 영어가 가능합니다. 국문 트랙명은 한국 발매 이름이고,
                영문 트랙명은 해외 발매 이름이 됩니다.
              </Text>
              <HStack width="100%" spacing={4}>
                <FormControl flex={1} isRequired>
                  <Input
                    name="track_name_kr"
                    value={formData.track_name_kr}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        track_name_kr: e.target.value,
                      })
                    }
                    placeholder="국문 트랙명"
                    borderRadius="md"
                    focusBorderColor="blue.400"
                  />
                </FormControl>
                <FormControl flex={1} isRequired>
                  <Input
                    name="track_name_en"
                    value={formData.track_name_en}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        track_name_en: e.target.value,
                      })
                    }
                    placeholder="영문 트랙명"
                    borderRadius="md"
                    focusBorderColor="blue.400"
                  />
                </FormControl>
              </HStack>
            </Box>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  뮤지션
                </FormLabel>
                <Select
                  name="musician"
                  value={formData.musician}
                  onChange={(e) =>
                    setFormData({ ...formData, musician: e.target.value })
                  }
                  borderRadius="md"
                  focusBorderColor="blue.400"
                >
                  <option value="">선택하세요</option>
                  {musicians.map((musician) => (
                    <option key={musician.id} value={musician.id}>
                      {musician.name_musician}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  언어
                </FormLabel>
                <Select
                  name="vocal_language"
                  value={formData.vocal_language}
                  onChange={(e) =>
                    setFormData({ ...formData, vocal_language: e.target.value })
                  }
                  borderRadius="md"
                  focusBorderColor="blue.400"
                >
                  <option value="">선택하세요</option>
                  {LANGUAGES.map((lang) => (
                    <option key={lang.value} value={lang.value}>
                      {lang.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  장르
                </FormLabel>
                <Select
                  name="genre_depth4"
                  value={formData.genre_depth4}
                  onChange={(e) =>
                    setFormData({ ...formData, genre_depth4: e.target.value })
                  }
                  borderRadius="md"
                  focusBorderColor="blue.400"
                >
                  <option value="">선택하세요</option>
                  {GENRES.map((genre) => (
                    <option key={genre.value} value={genre.value}>
                      {genre.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </HStack>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  작사가
                </FormLabel>
                <Input
                  name="lyricist_kr"
                  value={formData.lyricist_kr}
                  onChange={(e) =>
                    setFormData({ ...formData, lyricist_kr: e.target.value })
                  }
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  작사가 (영문)
                </FormLabel>
                <Input
                  name="lyricist_en"
                  value={formData.lyricist_en}
                  onChange={(e) =>
                    setFormData({ ...formData, lyricist_en: e.target.value })
                  }
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
            </HStack>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  작곡가
                </FormLabel>
                <Input
                  name="composer_kr"
                  value={formData.composer_kr}
                  onChange={(e) =>
                    setFormData({ ...formData, composer_kr: e.target.value })
                  }
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  작곡가 (영문)
                </FormLabel>
                <Input
                  name="composer_en"
                  value={formData.composer_en}
                  onChange={(e) =>
                    setFormData({ ...formData, composer_en: e.target.value })
                  }
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
            </HStack>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  편곡가
                </FormLabel>
                <Input
                  name="arranger_kr"
                  value={formData.arranger_kr}
                  onChange={(e) =>
                    setFormData({ ...formData, arranger_kr: e.target.value })
                  }
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  편곡가 (영문)
                </FormLabel>
                <Input
                  name="arranger_en"
                  value={formData.arranger_en}
                  onChange={(e) =>
                    setFormData({ ...formData, arranger_en: e.target.value })
                  }
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
            </HStack>

            <FormControl>
              <FormLabel fontWeight="medium" color="gray.700">
                가사
              </FormLabel>
              <Textarea
                name="lyrics"
                value={formData.lyrics}
                onChange={(e) =>
                  setFormData({ ...formData, lyrics: e.target.value })
                }
                rows={5}
                borderRadius="md"
                focusBorderColor="blue.400"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="medium" color="gray.700">
                메모
              </FormLabel>
              <Textarea
                name="description"
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
                rows={3}
                borderRadius="md"
                focusBorderColor="blue.400"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="medium" color="gray.700">
                분위기 (다중 선택)
              </FormLabel>
              <Box p={4} bg="blue.50" borderRadius="lg">
                <Wrap spacing={2}>
                  {formData.mood.map((moodValue) => {
                    const mood = MOODS.find((m) => m.value === moodValue);
                    return (
                      <WrapItem key={moodValue}>
                        <Tag
                          size="md"
                          borderRadius="full"
                          variant="solid"
                          colorScheme="blue"
                        >
                          <TagLabel>{mood?.label || moodValue}</TagLabel>
                          <TagCloseButton
                            onClick={() =>
                              handleMoodToggle({ value: moodValue })
                            }
                          />
                        </Tag>
                      </WrapItem>
                    );
                  })}
                </Wrap>
                <Box mt={4}>
                  <Wrap spacing={2}>
                    {MOODS.map((mood) => (
                      <WrapItem key={mood.value}>
                        <Tag
                          size="md"
                          borderRadius="full"
                          variant="outline"
                          colorScheme="blue"
                          cursor="pointer"
                          onClick={() => handleMoodToggle(mood)}
                          opacity={formData.mood.includes(mood.value) ? 0.5 : 1}
                          _hover={{ bg: "blue.50" }}
                        >
                          <TagLabel>{mood.label}</TagLabel>
                        </Tag>
                      </WrapItem>
                    ))}
                  </Wrap>
                </Box>
              </Box>
            </FormControl>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  MP3 파일 (최대 50MB)
                </FormLabel>
                <Input
                  type="file"
                  accept=".mp3"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    // 확장자 및 MIME 타입 체크
                    const isMp3 =
                      file.name.toLowerCase().endsWith(".mp3") &&
                      (file.type === "audio/mpeg" || file.type === "audio/mp3");
                    if (!isMp3) {
                      toast({
                        title: "잘못된 파일 형식",
                        description: "MP3 파일만 업로드할 수 있습니다.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                      });
                      e.target.value = ""; // 파일 선택 취소
                      return;
                    }
                    if (file.size > 50 * 1024 * 1024) {
                      toast({
                        title: "파일 크기 초과",
                        description: "MP3 파일은 50MB를 초과할 수 없습니다.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                      });
                      e.target.value = "";
                      return;
                    }
                    setMp3File(file);
                  }}
                  borderRadius="md"
                  p={1}
                />
              </FormControl>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  WAV 파일 (최대 300MB)
                </FormLabel>
                <Input
                  type="file"
                  accept=".wav"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    // 확장자 및 MIME 타입 체크
                    const isWav =
                      file.name.toLowerCase().endsWith(".wav") &&
                      (file.type === "audio/wav" ||
                        file.type === "audio/x-wav");
                    if (!isWav) {
                      toast({
                        title: "잘못된 파일 형식",
                        description: "WAV 파일만 업로드할 수 있습니다.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                      });
                      e.target.value = ""; // 파일 선택 취소
                      return;
                    }
                    if (file.size > 300 * 1024 * 1024) {
                      toast({
                        title: "파일 크기 초과",
                        description: "WAV 파일은 300MB를 초과할 수 없습니다.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                      });
                      e.target.value = "";
                      return;
                    }
                    setWavFile(file);
                  }}
                  borderRadius="md"
                  p={1}
                />
              </FormControl>
            </HStack>
          </VStack>
        </ModalBody>

        {isLoading && (
          <Box mb={4} p={4} bg="blue.50" borderRadius="lg">
            <Text mb={2} fontWeight="medium" color="blue.700">
              {uploadStatus}
            </Text>
            <VStack spacing={3}>
              <Box width="100%">
                <Text fontSize="sm" mb={1} color="blue.600">
                  MP3 파일 업로드 진행률
                </Text>
                <Progress
                  value={uploadProgress.mp3}
                  size="sm"
                  colorScheme="blue"
                  borderRadius="full"
                  hasStripe
                  isAnimated
                />
              </Box>
              <Box width="100%">
                <Text fontSize="sm" mb={1} color="blue.600">
                  WAV 파일 업로드 진행률
                </Text>
                <Progress
                  value={uploadProgress.wav}
                  size="sm"
                  colorScheme="blue"
                  borderRadius="full"
                  hasStripe
                  isAnimated
                />
              </Box>
            </VStack>
          </Box>
        )}

        <ModalFooter p={4} borderTopWidth={1} borderColor="gray.200">
          <Button variant="ghost" mr={3} onClick={onClose}>
            취소
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={isLoading}
            loadingText="저장 중..."
          >
            등록
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TrackModal;
